'use client';

import {useContext} from 'react';
import AuthContext from '@mgp-fe/shared/modules/auth/state/AuthContext.ts';
import {AuthContextValue} from '@mgp-fe/shared/modules/auth/domain.ts';
import {User} from '@mgp-fe/shared/core-api/domain/user.ts';

export default <T extends User = User>() => useContext(AuthContext) as AuthContextValue<T>;